
import { FaFacebook,FaInstagram, FaPhone, FaWhatsapp, FaYoutube } from 'react-icons/fa';

import {useState} from "react"
function Footer() {
const [showMore, setShowMore] = useState(false);

  const toggleShow = () => setShowMore(!showMore);

  const number = "+919199245536";
 
  const message = "Hello! Gyasuddin";

  const redirectToWhatsApp = () => {
    window.location.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  };

  const CallingMe = () => {
    window.location.href = `tel:${number}`;
  };
  return (
    <footer className="bg-dark text-light py-4">
      <div className="container">
        <div className="row">
          <div className="col-md-3 mb-3 mb-md-0">
            <h5>About Us</h5>
            <p className="small">
            OneStopService is your trusted partner for all home appliance repairs,web Development,Shop. With years of
              experience, we provide fast, reliable, and affordable services.
            </p>
          </div>
          <div className="col-md-3 mb-3 mb-md-0">
            <h5>Our Services</h5>
            <ul className="list-unstyled small">
                 <li>Responsive Website Design</li>
    <li>Business Website Development</li>
    <li>E-commerce Solutions</li>
    <li>SEO & Performance Optimization</li>
    <li>Ongoing Maintenance & Support</li>
     

 <div className={`collapse ${showMore ? 'show' : ''}`} id="moreServices">
        <ul className="list-unstyled">
        {/* Painter Services */}
          <li>Interior Painting</li>
          <li>Exterior Painting</li>
          <li>Residential Painting</li>
          <li>Commercial Painting</li>
          <li>Specialty Finishes</li>
          <li>Surface Preparation</li>
          <li>Staining & Varnishing</li>

              <li>AC Repair and Maintenance</li>
              <li>Refrigerator Repair</li>
              <li>Washing Machine Repair</li>
              <li>Other Home Appliance Repairs</li>


         
          {/* Plumber Services */}
          <li>Leak Detection & Repair</li>
          <li>Drain Cleaning & Unclogging</li>
          <li>Water Heater Services</li>
          <li>Fixture Installation</li>
          <li>Pipe Repair & Replacement</li>
          <li>Emergency Plumbing</li>

          {/* Cleaner Services */}
          <li>Residential Cleaning</li>
          <li>Commercial Cleaning</li>
          <li>Deep Cleaning</li>
          <li>Move-In / Move-Out Cleaning</li>
          <li>Carpet & Upholstery Cleaning</li>
          <li>Window Cleaning</li>

        </ul>
      </div>

      {/* Toggle Button */}
      <button
        className="btn btn-link p-0"
        type="button"
        onClick={toggleShow}
        aria-expanded={showMore}
        aria-controls="moreServices"
      >
        {showMore ? 'See Less' : 'See More'}
      </button>

              
            </ul>
          </div>
          <div className="col-md-3">
            <h5>Contact Us</h5>
            <h6>Address</h6>
            <address className="small">
              841226 Mohiuddinpur
              <br />
              Siwan Bihar
              <br />
              <a href="tel:+919199245536">
              Phone: 9199245536
              </a>
              <br />
              Email: <a href="mailto:gyasuddinali0786@gmail.com" className="text-info">gyasuddinali0786@gmail.com</a>

            </address>
{/* <h6>Branch 2</h6>
            <address className="small">
              Mirganj
              <br />
              Gopalganj,Bihar
              <br />
              <a href="tel:+919199245536">
              Phone: 9199245536
              </a>
              <br />
              Email: <a href="mailto:gyasuddinali0786@gmail.com" className="text-info">gyasuddinali0786@gmail.com</a>
              
            </address> */}
          </div>

 
          <div className="col-md-3 mb-3 mb-md-0">
            <h5>Visit our social website</h5>
            <ul className="list-unstyled small">
              <li> <a
                href="https://www.instagram.com/iam_gyasu/"
                className="fs-2 mx-2 float-start"
              >
                <FaInstagram style={{color:'#d4af37'}}/>
              </a></li>
              <li>              <a
                href="https://www.facebook.com/gyasusrkian91992"
                className="fs-2 mx-2 float-start"
              >
                <FaFacebook style={{color:'#d4af37'}}/>
              </a>
                  </li>
                  <li>              <a
                href="#"
                className="fs-2 mx-2 float-start"
              >
                <FaYoutube style={{color:'#d4af37'}} />
              </a>
                  </li>
              {/* <li>
                 <a
                href="#"
                className="fs-2 mx-2 float-start"
              >
                <FaPhone onClick={CallingMe} style={{color:'blue'}} /></a></li> */}
                {/* <li>
                   <a
                href="#"
                className="fs-2 mx-2 float-start"
              >
                <FaWhatsapp onClick={redirectToWhatsApp} style={{color:'green'}} /></a></li>
                 */}
            </ul>
          </div>
        </div>    
       <div className="text-center small mt-4" style={{ marginBottom: '80px' }}>
  &copy; {new Date().getFullYear()} OneStopService. All rights reserved.
</div>

      </div>
    </footer>
  )
}

export default Footer

